/*
 * @Author: owen
 * @Date: 2022-04-07 11:00:46
 * @LastEditors: owen
 * @LastEditTime: 2022-05-06 12:01:26
 * @FilePath: \app-pcweb\src\locale\index.js
 */

import store from "@/lobby_common/store";
import { getLocalStorage, setLocalStorage } from "@/lobby_common/utils/auth";
// import { localesimg } from "@/lobby_common/utils/assetsImages.js";
import elen from "element-ui/lib/locale/lang/en";

import Vue from "vue";
import VueI18n from "vue-i18n";

// import en from "./en_US";
let packetConfig = null;
export async function setPacketConfig(info = {}) {
  packetConfig = { ...info };
}
const getPacketConfig = () => {
  return store.getters.getPacketConfig || packetConfig;
};

const path = {
  en: ["en_US", "en"], // 英文
  tw: ["zh_TW", "zh-TW"], // 繁体
  pu: ["pt_PT", "pt"], // 葡语
  id: ["id_ID", "id"], // 印尼语
  ja: ["ja_JP", "ja"], // 日语
  ko: ["ko_KR", "ko"], // 韩语
  th: ["th_TH", "th"], // 泰语
  vi: ["vi_VN", "vi"], // 越南语
  es: ["es_ES", "es"], // 西班牙语
  zh: ["zh_TW", "zh_TW"], // 中文
  ru: ["ru_RU", "ru-RU"], // 俄语
  hi: ["hi_HI", "hi"], // 印地语//1
  ar: ["ar_AR", "ar"], // 阿拉伯语
  tr: ["tr_TR", "tr-TR"], // 土耳其语
  ta: ["ta_TA", "ta"], // 泰米尔语
  te: ["te_TE", "te"], // 泰卢固语
  ms: ["ms_MS", "ms"], // 马来语
  fil: ["fil_FIL", "fil"], // 菲律宾语 芬兰语
  it: ["it_IT", "it"], // 意大利语
  fr: ["fr_FR", "fr"], // 法语
  pa: ["pa_PA", "pa"], // 旁遮普语//1
  ps: ["ps_PS", "ps"], // 普什图语//1
  uk: ["uk_UK", "uk"], // 乌克兰语 //1
  bn: ["bn_BN", "bn"], // 孟加拉语
  ur: ["ur_UR", "ur"], // 乌尔都语//1
  ig: ["ig_IG", "ig"], // 伊博语  //1
  ha: ["ha_HA", "ha"], // 豪萨语 //1
  yo: ["yo_YO", "yo"], // 约鲁巴语//1
  kk: ["kk_Kk", "kk"], // 哈萨克语//1
  ku: ["ku_KU", "ku"], // 库尔德语
};

Vue.use(VueI18n);
const messages = {
  en: {
    // ...en,
    ...elen,
  },
};

/**
 * Available locales
 */
const localesList = [
  {
    title: "English",
    locale: "en",
    abbr: "ENG",
    icon: require("@/lobby_common/assets/country/en.png"),
    // icon: localesimg["en"],
  },
  {
    title: "中文(繁體)",
    locale: "tw",
    abbr: "CHTW",
    icon: require("@/lobby_common/assets/country/tw.png"),
  },
  {
    title: "Portugues do Brasil",
    locale: "pu",
    abbr: "PU",
    icon: require("@/lobby_common/assets/country/pu.png"),
  },
  {
    title: "Indonesia",
    locale: "id",
    abbr: "ID",
    icon: require("@/lobby_common/assets/country/id.png"),
  },
  // 日韩泰越
  {
    title: "日本語",
    locale: "ja",
    abbr: "JA",
    icon: require("@/lobby_common/assets/country/ja.png"),
  },
  {
    title: "한국어",
    locale: "ko",
    abbr: "KO",
    icon: require("@/lobby_common/assets/country/ko.png"),
  },
  {
    title: "ภาษาไทย",
    locale: "th",
    abbr: "TH",
    icon: require("@/lobby_common/assets/country/th.png"),
  },
  {
    title: "Tiếng Việt",
    locale: "vi",
    abbr: "VI",
    icon: require("@/lobby_common/assets/country/vi.png"),
  },
  {
    title: "España", // 西班牙语
    locale: "es",
    abbr: "ES",
    icon: require("@/lobby_common/assets/country/es.png"),
  },
  {
    title: "Русский", // 俄语
    locale: "ru",
    abbr: "RU",
    icon: require("@/lobby_common/assets/country/ru.png"),
  },
  {
    title: "हिंदी", // 印地语
    locale: "hi",
    abbr: "HI",
    icon: require("@/lobby_common/assets/country/hi.png"),
  },
  {
    title: "العربية", // 阿拉伯语
    locale: "ar",
    abbr: "AR",
    icon: require("@/lobby_common/assets/country/ar.png"),
  },
  {
    title: "Türkçe", // 土耳其语
    locale: "tr",
    abbr: "TR",
    icon: require("@/lobby_common/assets/country/tr.png"),
  },
  {
    title: "தமிழ்", // 泰米尔语
    locale: "ta",
    abbr: "TA",
    icon: require("@/lobby_common/assets/country/ta.png"),
  },
  {
    title: "తెలుగు", // 泰卢固语
    locale: "te",
    abbr: "TE",
    icon: require("@/lobby_common/assets/country/te.png"),
  },
  {
    title: "Bahasa Melayu", // 马来语
    locale: "ms",
    abbr: "MS",
    icon: require("@/lobby_common/assets/country/ms.png"),
  },
  {
    title: "Filipino", // 菲律宾语
    locale: "fil",
    abbr: "FII",
    icon: require("@/lobby_common/assets/country/fil.png"),
  },
  {
    title: "Italiano", // 意大利语
    locale: "it",
    abbr: "IT",
    icon: require("@/lobby_common/assets/country/it.png"),
  },
  {
    title: "Français", // 法语
    locale: "fr",
    abbr: "FR",
    icon: require("@/lobby_common/assets/country/fr.png"),
  },
  {
    title: "ਪੰਜਾਬੀ", // 旁遮普语
    locale: "pa",
    abbr: "PA",
    icon: require("@/lobby_common/assets/country/pa.png"),
  },
  {
    title: "پښتو", //  普什图语
    locale: "ps",
    abbr: "PA",
    icon: require("@/lobby_common/assets/country/ps.png"),
  },
  {
    title: "Українська", //  乌克兰语
    locale: "uk",
    abbr: "UK",
    icon: require("@/lobby_common/assets/country/ua.png"),
  },
  {
    title: "বাংলা", //  孟加拉语
    locale: "bn",
    abbr: "BN",
    icon: require("@/lobby_common/assets/country/bn.png"),
  },
  {
    title: "اردو", //  乌尔都语
    locale: "ur",
    abbr: "UR",
    icon: require("@/lobby_common/assets/country/ur.png"),
  },
  {
    title: "Igbo", //  伊博语
    locale: "ig",
    abbr: "IG",
    icon: require("@/lobby_common/assets/country/ig.png"),
  },
  {
    title: "Hausa", //  豪萨语
    locale: "ha",
    abbr: "HA",
    icon: require("@/lobby_common/assets/country/ha.png"),
  },
  {
    title: "Yorùbá", //  约鲁巴语
    locale: "yo",
    abbr: "YO",
    icon: require("@/lobby_common/assets/country/yo.png"),
  },
  {
    title: "Қазақ тілі", //   哈萨克语
    locale: "kk",
    abbr: "Kk",
    icon: require("@/lobby_common/assets/country/kk.png"),
  },
  {
    title: "Kurdî", //   库尔德语
    locale: "ku",
    abbr: "KO",
    icon: require("@/lobby_common/assets/country/ku.png"),
  },
];

let filterArr = [localesList[0]];
let languageArr = [];
const language_info = getPacketConfig()?.packetInfo?.baseInfo?.languages || [
  "en",
];

// 获取浏览器语言
const getNavigatorLang = () => {
  let language = "";
  const jsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
  const langObj = {
    en: "en",
    "pt-br": "pu",
    "pt-BR": "pu",
    "zh-cn": "tw",
    "zh-tw": "tw",
    zh: "tw",
    id: "id",
    ja: "ja",
    ko: "ko",
    th: "th",
    vi: "vi",
    es: "es",
    ru: "ru",
    ar: "ar",
    tr: "tr",
    ta: "ta",
    te: "te",
    ms: "ms",
    fil: "fil",
    it: "it",
    fr: "fr",
    pa: "pa",
    ps: "ps",
    uk: "uk",
    bn: "bn",
    ur: "ur",
    ig: "ig",
    ha: "ha",
    yo: "yo",
    kk: "kk",
    ku: "ku",
  };

  language = langObj[jsSrc];
  // console.log(language, "----------");
  console.log("getNavigatorLang", jsSrc, language);
  // alert('浏览器语言：'+jsSrc)
  return language;
};

// 获默认语言
const getDefaultLang = () => {
  // 本地
  const localLanguage = getLocalStorage("lang")?.lang;
  let language = localLanguage;
  const urlParams = new URLSearchParams(window.location.search);
  const urlLanguage = urlParams?.get?.("language");
  console.log(
    "urlLanguage",
    urlLanguage,
    localLanguage,
    language,
    languageArr,
    getPacketConfig()?.packetInfo
  );
  if (urlLanguage && languageArr?.includes(urlLanguage)) {
    language = urlLanguage;
    setLocalStorage("lang", { lang: urlLanguage });
  }
  if (!language) {
    let params = window.localStorage.getItem("localInitQuery");
    if (params) {
      params = JSON.parse(params);
    }
    let configLang = "";
    if (getPacketConfig()?.packetInfo?.config?.defaultLanguage === "auto") {
      // 浏览器系统语言
      configLang = getNavigatorLang();
    } else {
      // 后台配置
      configLang = getPacketConfig()?.packetInfo?.config?.defaultLanguage;
    }

    language = params?.language || configLang || "en";
  }
  // console.log('getDefaultLang', language, languageArr)
  if (
    languageArr?.includes(language) ||
    (!getPacketConfig()?.packetInfo?.baseInfo?.languages?.length &&
      localLanguage)
  ) {
    // 后台有配置且包含浏览器语言
    return language;
  } else {
    // 后台无配置或其他情况
    return languageArr[0] || "en";
  }
};

export async function setLocaleArr(info) {
  const list = info?.length
    ? info
    : getPacketConfig()?.packetInfo?.baseInfo?.languages || ["en"];
  languageArr = list || [];
  const arr = localesList?.filter((i) => languageArr?.includes(i.locale));
  filterArr = arr.length ? arr : [localesList[0]];
  // 设置多语言下拉列表
  store.commit("setLocalesList", filterArr);
  // 设置多语言资源 动态按需引入
  const lang1 = getDefaultLang();
  // console.log(lang1, "getDefaultLang");
  const la1 = await import(`./${path[lang1][0]}/index.js`);
  // const el1 = await import(`element-ui/lib/locale/lang/${path[lang1][1]}`);
  i18n.mergeLocaleMessage(lang1, { ...la1.default });
  // console.log(lang1, "lang1");
  if (lang1 !== "en") {
    const lang2 = "en";
    // console.log(lang2, "lang2");
    const la2 = await import(`./${path[lang2][0]}/index.js`);
    // const el2 = await import(`element-ui/lib/locale/lang/${path[lang2][1]}`);
    i18n.mergeLocaleMessage(lang2, { ...la2.default });
    // console.log('i18n.mergeLocaleMessage')
  }
  // console.log('language_info11111', languageArr, filterArr)
}
// setLocaleArr(language_info);

export const locales = filterArr;

/**
 * VueI18n instance
 */
const i18n = new VueI18n({
  // set locale options: en | zh | pu
  locale: getDefaultLang(),
  fallbackLocale: "en", // 如果当前语言翻译缺失，则使用英文作为回退语言
  silentFallbackWarn: true, //
  // set locale messages
  messages,
});

/**
 * Set locale to new value at Vue and Vuex.
 *
 * @param {Boolean} newLocale themeDark new value
 */
export async function setLocale(locale) {
  if (i18n.locale !== locale) {
    // console.log(`[Locale] Set to "${locale}"`);
    i18n.locale = locale || getDefaultLang();
    store.commit("setLang", i18n.locale);
  }
}

export default i18n;
